import useSeo from "@/lib/useSeo";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FinishingHero from "@/components/finishing/FinishingHero";
import FinishingMirror from "@/components/finishing/FinishingMirror";
import FinishingSolution from "@/components/finishing/FinishingSolution";
import FinishingProducts from "@/components/finishing/FinishingProducts";
import LaminatorShowcase from "@/components/finishing/LaminatorShowcase";
import VinylCutterShowcase from "@/components/finishing/VinylCutterShowcase";
import FinishingUnlocks from "@/components/finishing/FinishingUnlocks";
import FinishingPositioning from "@/components/finishing/FinishingPositioning";
import FinishingHowItWorks from "@/components/finishing/FinishingHowItWorks";
import FinishingCTA from "@/components/finishing/FinishingCTA";

export default function FinishingPage() {
  useSeo({
    title:
      "Finishing — ED Tech Depot | Laminators, Vinyl Cutters & Banner Accessories",
    description:
      "Laminators, vinyl cutters, and banner finishing accessories for K-12 schools. Turn printed posters and banners into polished, display-ready materials in-house.",
    path: "/finishing",
  });

  return (
    <div data-testid="finishing-page" className="min-h-screen bg-[#F4F6F4]">
      <Header />
      <main>
        <FinishingHero />
        <FinishingMirror />
        <FinishingSolution />
        <FinishingProducts />
        <LaminatorShowcase />
        <VinylCutterShowcase />
        <FinishingUnlocks />
        <FinishingPositioning />
        <FinishingHowItWorks />
        <FinishingCTA />
      </main>
      <Footer />
    </div>
  );
}
